export const version = '2.44.4';
//# sourceMappingURL=version.js.map